import {
  Button,
  Container,
  Divider,
  Grid,
  Group,
  Image,
  SimpleGrid,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { motion } from "framer-motion";
import React, { useCallback, useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useDispatch, useSelector } from "react-redux";
import rehypeRaw from "rehype-raw";
import {
  addArticleGroupTicket,
  addToCartTracking,
} from "../../../../common/sale";
import { STATE_CULTURE, STATE_CURRENCY } from "../../../../common/state";
import placeholder from "../../../../images/placeholder.jpg";
import GroupArticle from "./GroupArticle";
import classes from "./MultiTicket.module.css";

const MultiTicket = ({ product, description }) => {
  const { culture, language, currency } = useSelector((state) => ({
    culture: state.cookies[STATE_CULTURE],
    language: state.language,
    currency: state.cookies[STATE_CURRENCY],
  }));
  const buildEmptyGroupTicket = useCallback(() => {
    if (!product?.plu) {
      return null;
    }

    return {
      plu: product.plu,
      quantity: 1,
      ticketOwners: [],
    };
  }, [product?.plu]);

  const [groupTicketCart, setGroupTicketCart] = useState(() => {
    const initialItem = buildEmptyGroupTicket();
    return initialItem ? [initialItem] : [];
  });
  const [isLoading, setIsLoading] = useState(false);
  const rdxDispatch = useDispatch();
  const mobile = useMediaQuery("(max-width: 768px)");

  const getTranslation = product?.translation.filter(
    (el) => el?.culture === culture
  )?.[0];

  useEffect(() => {
    const initialItem = buildEmptyGroupTicket();
    if (!initialItem) {
      setGroupTicketCart([]);
      return;
    }
    setGroupTicketCart([initialItem]);
  }, [buildEmptyGroupTicket]);

  const addGroupTicket = () => {
    if (!groupTicketCart?.length) {
      return;
    }

    const trackingGroupTicket = [
      {
        id: product.plu,
        quantity: 1,
        price: product.price.amountInclVat,
        name: product.name,
      },
    ];
    const callback = (status, msg) => {
      setIsLoading(false);
      if (status < 400) {
        const reset = buildEmptyGroupTicket();
        setGroupTicketCart(reset ? [reset] : []);
      }
    };

    addToCartTracking(currency, trackingGroupTicket);
    setIsLoading(true);
    rdxDispatch(addArticleGroupTicket(groupTicketCart, callback));
  };
  console.log("groupTicketCart", groupTicketCart);
  return (
    <Container className={classes.containerWrapper}>
      <Grid gutter={28}>
        <Grid.Col span={{ sm: 12, md: 7 }}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{ height: "100%" }}
          >
            <Image
              src={product.images && product.images}
              fallbackSrc={placeholder}
              radius={"sm"}
              fit="cover"
              style={{ height: !product.images && "100%" }}
              h={
                mobile && product.images
                  ? "20rem"
                  : mobile && !product.images
                  ? "20rem"
                  : "25rem"
              }
              alt={`${language.ProductAltLabel} ${getTranslation.name}`}
            />
          </motion.div>
        </Grid.Col>
        <Grid.Col span={{ sm: 12, md: 5 }} className={classes.container}>
          <div className={classes.titleWrapper}>
            <h1 className="productTitle" style={{ fontSize: "1.5rem" }}>
              {getTranslation.name}
            </h1>
          </div>
          <p style={{ marginTop: "0.5rem", marginBottom: "1.5rem" }}>
            {language.GroupTicketDescription}
          </p>
          <SimpleGrid cols={1} style={{ gap: ".5rem" }}>
            {product.ticketHolders.map((el) => (
              <div key={el.categoryId}>
                <GroupArticle
                  allTicketsData={product.ticketHolders}
                  ticketData={el}
                  groupTicketCart={groupTicketCart}
                  setGroupTicketCart={setGroupTicketCart}
                  item={groupTicketCart?.[0]}
                />
                <Divider size="xs" />
              </div>
            ))}
          </SimpleGrid>
          <div className={classes.actionGrid}>
            <div
              className={classes.hideLabel}
              role="region"
              aria-live="assertive"
            />
            <Group>
              <span className={classes.price} component="span">
                {!product.isOpenPrice ? product.priceInclVat : ""}
              </span>
            </Group>
            <div
              className={classes.alertWrapper}
              role="region"
              aria-live="polite"
            >
              <Button
                variant="filled"
                size="md"
                className="regularButton add_to_cart_product"
                classNames={{
                  label: "add_to_cart_product",
                  inner: "add_to_cart_product",
                }}
                color="var(--button-primary-bg-color)"
                onClick={addGroupTicket}
                disabled={isLoading}
                loading={isLoading}
                style={{
                  width: "100%",
                  transition: "all 0.2s ease-in-out",
                }}
              >
                {language.AddToCartBtn}
              </Button>
            </div>
          </div>
          <Divider my="lg" />
          <h2 className={`${classes.descriptionTitle} descriptionTitle`}>
            {language.Description}
          </h2>
          <div className={`${classes.descriptionBody} productDescription`}>
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>
              {description ? description : getTranslation.description}
            </ReactMarkdown>
          </div>
        </Grid.Col>
      </Grid>
    </Container>
  );
};

export default MultiTicket;
